// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3724":"VoltoFormBlockEdit","4328":"Widgets","5772":"plone-volto-components-manage-Controlpanels-Aliases"}[chunkId] + "." + {"3724":"22b493c6","4328":"5b14901f","5772":"1e7870a9"}[chunkId] + ".chunk.css";
};